// Original pick converts object to array, if picking number keys:
// _.pick({ a: { 4: "foo" } }, ["a.4"]);
// => {a: (5) [empty × 4, 'foo']}
var initialValue = function initialValue(value) {
  return Array.isArray(value) ? [] : {};
};

export default function pick(object, paths) {
  var data = initialValue(object);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var path = _step.value;
      var target = data;
      var source = object || {};
      var parts = path.split(".");
      var lastIndex = parts.length - 1;

      for (var index = 0; index < parts.length; ++index) {
        var part = parts[index];

        if (target && !(part in target)) {
          var value = source[part];
          var isLastPart = index === lastIndex;
          target[part] = isLastPart ? value : initialValue(value);
        }

        if (target) {
          target = target[part];
        }

        source = source[part] || {};
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return data;
}